import { AppState } from 'store/types';

export const getModalsState = (state: AppState) => state.modals;